import { stylesheet } from "typestyle";

const styles = stylesheet({
  lockIcon: {
    width: "16px",
  },
});

export default styles;
